theme.headerSearch = (function () {
  let initialized = false;
  let trigger = null;
  function closeSearch(restoreFocus) {
    const overlay = document.getElementById("predictive__search_overlay");
    if (!overlay) return;
    overlay.classList.remove("active");
    overlay.setAttribute("aria-hidden", "true");
    overlay.inert = true;
    document.body.classList.remove("hd-search-open");
    document.querySelectorAll(".header__actions_btn--search").forEach(button => button.setAttribute("aria-expanded", "false"));
    if (typeof removeTrapFocus === "function") removeTrapFocus(restoreFocus && trigger && trigger.isConnected ? trigger : undefined);
    else if (restoreFocus && trigger && trigger.isConnected) trigger.focus();
    trigger = null;
  }
  return function () {
    const overlay = document.getElementById("predictive__search_overlay");
    if (overlay && !overlay.classList.contains("active")) {
      overlay.inert = true;
      overlay.setAttribute("aria-hidden", "true");
    }
    if (initialized) return;
    initialized = true;
    document.addEventListener("click", event => {
      const button = event.target.closest(".header__actions_btn--search");
      const panel = document.getElementById("predictive__search_overlay");
      if (!panel) return;
      if (button) {
        event.preventDefault();
        trigger = button;
        panel.inert = false;
        panel.setAttribute("aria-hidden", "false");
        panel.classList.add("active");
        document.body.classList.add("hd-search-open");
        button.setAttribute("aria-expanded", "true");
        const input = panel.querySelector('input[type="search"]');
        if (typeof trapFocus === "function") trapFocus(panel, input || panel);
        else if (input) input.focus();
        return;
      }
      if (event.target.closest(".hd-search-scrim")) closeSearch(false);
      else if (event.target.closest("#search__close_btn")) closeSearch(true);
      else {
        const suggestion = event.target.closest(".hd-search-suggestion");
        if (suggestion && panel.contains(suggestion)) {
          const input = panel.querySelector('input[type="search"]');
          if (input) {
            input.value = suggestion.dataset.searchQuery || "";
            input.focus();
            input.dispatchEvent(new Event("input", { bubbles: true }));
          }
        }
      }
      if (panel.classList.contains("active") && !event.target.closest("#predictive__search_overlay")) closeSearch(false);
    });
    document.addEventListener("keydown", event => {
      if (event.key === "Escape" && document.getElementById("predictive__search_overlay")?.classList.contains("active")) {
        event.preventDefault();
        closeSearch(true);
      }
    });
    document.addEventListener("shopify:section:unload", () => closeSearch(false));
  };
})();
